import { Component, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { LocalizedTextModel } from 'shared/definition';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'wx-localized-text-input',
  templateUrl: './localized-text-input.component.html',
  styleUrls: ['./localized-text-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LocalizedTextInputComponent),
      multi: true
    }
  ]
})
export class LocalizedTextInputComponent implements OnInit, ControlValueAccessor {


  value: LocalizedTextModel = {}

  cultures = ['en', 'zh'];
  onChange: (_: any) => void;
  writeValue(obj: any): void {
    this.value = obj || {}

  }
  registerOnChange(fn: any): void {
    this.onChange = fn;

  }
  registerOnTouched(fn: any): void {

  }
  setDisabledState?(isDisabled: boolean): void {

  }

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
  }

  getText(cul: string) {
    return this.value[cul];

  }

  tanslate(cul:string) {
    return this.translateService.get(`Language.${cul}`)

  }

  setText(cul: string, text: string) {
    this.value[cul] = text;
    this.onChange(this.value);
  }



}
